package com.vizio.redwolf.auth.api

data class HasPinInfo(val accessToken: String)

data class CreatePinInfo(val accessToken: String, val pin: String)

data class ValidatePinInfo(val accessToken: String, val pin: String)

data class DeletePinInfo(val accessToken: String)

data class UpdatePinInfo(val accessToken: String, val pin: String)
